import { Component } from '@angular/core';
import { ExpenditureCategoryService } from '../expenditure-category.service';
import { ExpenditureCategory } from '../expenditure-category';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-expenditure-category-edit',
  templateUrl: 'edit.component.html',
})
export class ExpenditureCategoryEditComponent {
  /**
   * Details of the expenditureCategory being edited.
   */
  public expenditureCategory: ExpenditureCategory;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {ExpenditureCategoryService} expenditureCategoryService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private expenditureCategoryService: ExpenditureCategoryService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.expenditureCategoryService.loading.subscribe(
      result => (this.isLoading = result),
    );
    this.route.params.subscribe(params =>
      this.loadExpenditureCategory(params.id),
    );
  }

  /**
   * Perform the edit action which send the edited expenditureCategory to the backend.
   */
  public edit() {
    const editExpenditureCategory = this.expenditureCategoryService
      .updateExpenditureCategory(
        this.expenditureCategory.id,
        this.expenditureCategory,
      )
      .subscribe(
        (result: ExpenditureCategory) => {
          this.notificationService.success(
            `ExpenditureCategory Updated`,
            `The expenditureCategory ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.expenditureCategory = new ExpenditureCategory();
          editExpenditureCategory.unsubscribe();
          this.router.navigate(['/expenditure-categories']);
        },
        err => {
          this.notificationService.error(
            `ExpenditureCategory Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/expenditure-categories']);
        },
      );
  }

  /**
   * Loads the requested expenditureCategory so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadExpenditureCategory(id: string) {
    this.expenditureCategoryService.findExpenditureCategory(id).subscribe(
      result => {
        this.expenditureCategory = result;
      },
      err => {
        this.notificationService.error(
          `ExpenditureCategory Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/expenditure-categories']);
      },
    );
  }
}
